// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { approveProposedActionRequestToJson, approveProposedActionResponseFromJson, generateDraftPreviewRequestToJson, generateDraftPreviewResponseFromJson, rejectProposedActionRequestToJson, rejectProposedActionResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function generateDraftPreview(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/GenerateDraftPreview', generateDraftPreviewRequestToJson(request));
    return generateDraftPreviewResponseFromJson(raw);
}
export function generateDraftPreview$(request, options) {
    return defer(() => generateDraftPreviewWithTransport$(getGlobalTransport(), request, options));
}
export function generateDraftPreviewWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/GenerateDraftPreview', generateDraftPreviewRequestToJson(request), options)
        .pipe(map(resp => generateDraftPreviewResponseFromJson(resp)));
}
export async function approveProposedAction(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/ApproveProposedAction', approveProposedActionRequestToJson(request));
    return approveProposedActionResponseFromJson(raw);
}
export function approveProposedAction$(request, options) {
    return defer(() => approveProposedActionWithTransport$(getGlobalTransport(), request, options));
}
export function approveProposedActionWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/ApproveProposedAction', approveProposedActionRequestToJson(request), options)
        .pipe(map(resp => approveProposedActionResponseFromJson(resp)));
}
export async function rejectProposedAction(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/RejectProposedAction', rejectProposedActionRequestToJson(request));
    return rejectProposedActionResponseFromJson(raw);
}
export function rejectProposedAction$(request, options) {
    return defer(() => rejectProposedActionWithTransport$(getGlobalTransport(), request, options));
}
export function rejectProposedActionWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/RejectProposedAction', rejectProposedActionRequestToJson(request), options)
        .pipe(map(resp => rejectProposedActionResponseFromJson(resp)));
}
